
import classNames from 'classnames';
import React, { Component } from 'react';
import { Carousel } from '.';
import { publicUrl } from '../../client/utils';


export default class Testimonials extends Component {

  constructor(props) {
    super(props);

    this.state = {
      index: 0,
    };

  }

  updateIndex(index, onComplete) {
    this.setState({
      index,
    }, onComplete);
  }

  handleClick(index) {
    this.updateIndex(index, () => {
      this.carousel.goto(index);

      // log the view of the testimonial.
      // Note that we do not log this view on page load (showing "slide0") which may skew the data
      const selectedTestimonial = `slide${index}`;

      window.dataLayer && window.dataLayer.push({
        'event': 'customEvent',
        'eventCategory': 'portal-homepage-testimonials',
        'eventAction': 'view',
        'eventLabel': selectedTestimonial,
      });
    });
  }

  render() {

    const {
      children,
    } = this.props;

    const { index } = this.state;

    return (
      <div className="testimonials">
        <h2>What our partners have to say...</h2>
        <Carousel
          ref={c => this.carousel = c}
          onChange={this.updateIndex.bind(this)}
        >
          {children}
        </Carousel>
        <ul className="testimonials__menu">
          {children.map((child, i) => (
            <li
              key={i}
              onClick={this.handleClick.bind(this, i)}
              className={classNames({
                'testimonials__menu-item': true,
                'testimonials__menu-item--selected': (index === i),
              })}
            >
              <img src={publicUrl(`/media/img/testimonials/${child.props.id}-logo.jpg`)} alt={child.props.company} />
              <span>{child.props.company}</span>
            </li>
          ))}
        </ul>
      </div>
    );

  }

}



// WEBPACK FOOTER //
// ./client/components/Testimonials.jsx